export default __webpack_public_path__ + "media/images/gallery/13-26735f1a9765d3a76c2fac6299b93bdf.jpg";